import { makeStyles } from '@material-ui/styles';
import { ITheme } from '../../../style/theme';
import { colors } from '../../../style/colors';

export const useStyles = makeStyles<ITheme>((theme) => ({
  container: {
    display: 'grid',
    justifyItems: 'center',
    gap: 5,
    '& svg': {
      marginBottom: 5,
    },
  },
  info: {
    fontWeight: 700,
    color: colors.darkGray,
    whiteSpace: 'pre-line',
    textAlign: 'center',
  },
  resetButton: {
    color: colors.darkestBlue,
    fontWeight: 700,
    paddingBottom: 24,
    cursor: 'pointer',
  },
}));
